<template>
  <div>
    <BreadCrumb
      :path="[
        {
          title: `${userData.display_name}`,
        },
        {
          title: 'MyPeople',
          route: '/contacts',
        },
      ]"
    />

    <MainContentPanel title="MyPeople">
      <div class="uk-flex">
        <MainContentPanel
          title="MyContacts"
          data-cy="My-Contacts-Panel"
          UkButtonIcon="user"
          buttonText="Add New"
          tooltip=""
          :buttonAction="openAddContacts"
          :medium="true"
          padding="small"
          class="uk-width-2-3 uk-margin-right"
        >
          <!-- // Team tags: Deprecated  -->
          <!-- <PrimeDataTable :key="contactsUpdated" ref="peopleDataTable" :pagination="false"  :scrollHeight="`400px`" :tableConfig="tablePeopleConfig"
                        :tableOptions="tablePeopleOptions" :loadDataFunction="loadContacts" :addTag="addTagsShow" @addTags="addTags" @removeTag="removeTag"
                        @selectedRows="(data) => (selectedPeople = data)" :tagsData="tags" @selectedColumns="tableToggleData"
                        /> -->
          <PrimeDataTable
            :key="contactsUpdated"
            ref="peopleDataTable"
            :pagination="false"
            :scrollHeight="`400px`"
            :tableConfig="tablePeopleConfig"
            @adding="closeAddContacts"
            :tableOptions="tablePeopleOptions"
            :loadDataFunction="loadContacts"
            @selectedRows="data => (selectedPeople = data)"
            @selectedColumns="tableToggleData"
          />
        </MainContentPanel>
        <MainContentPanel
          title="MyRosters"
          data-cy="My-Rosters-Panel"
          UkButtonIcon="users"
          buttonText="Add New"
          tooltip=""
          padding="small"
          :medium="true"
          :buttonAction="openCreateTeam"
          class="uk-width-1-3 uk-margin-remove-top"
        >
          <PrimeDataTable
            ref="teamDataTable"
            :pagination="false"
            :scrollHeight="`400px`"
            :tableConfig="tableTeamConfig"
            :teamRoster="true"
            :tableOptions="tableTeamOptions"
            :loadDataFunction="loadTeams"
            @selectedColumns="tableToggleData"
          />
        </MainContentPanel>
      </div>
    </MainContentPanel>
  </div>
</template>
<script>
import { defineAsyncComponent } from 'vue';
import BreadCrumb from '@/components/general/BreadCrumb';
import MainContentPanel from '@/components/display/general/MainContentPanel';
import { mapActions, mapGetters, mapState } from 'vuex';
import { xhr } from '../../xhr/endpoints';

export default {
  name: 'ClientContacts',

  components: {
    BreadCrumb,
    MainContentPanel,
    PrimeDataTable: defineAsyncComponent(() => import('@/components/table/PrimeDataTable.vue')),
  },

  data() {
    return {
      contactsUpdated: 0,
      // Team tags: Deprecated
      // tags: [],
      // tagsOptions: [],
      // teamTagsOptions: [],
      selectedPeople: [],
      // addTagsShow : false,
      adding: false,
      updateData: {},
    };
  },
  watch: {
    // Team tags: Deprecated
    // selectedPeople(value){
    //   if(value.length === 0)
    //     this.addTagsShow = false
    //   else
    //     this.addTagsShow = true
    //   this.tags = []
    // }
  },
  computed: {
    ...mapState(['idToken', 'userData']),

    ...mapGetters(['tableToggleData', 'sortAndFilter']),

    tablePeopleOptions() {
      return {
        // globalFilterFields: ['firstname'],
        rowEditable: {
          edit: true,
          action: this.handleContactUpdate,
        },
        tableName: 'tableClientPeople',
        placeHolderData: true,
        archiveSelected: {
          action: async ({ items, success, failed }) => {
            await this.archiveMultipleContacts(items, success, failed, true);
          },
          title: 'Archive Contacts',
          tooltip: 'Archive the checked contacts',
        },
        restoreSelected: {
          action: async ({ items, success, failed }) => {
            await this.archiveMultipleContacts(items, success, failed, false);
          },
          title: 'Restore Documents',
          tooltip: 'Restore archived items',
        },
        headerConfig: [
          [
            {
              header: 'firstname',
              field: 'firstname',
              sortable: true,
            },
            {
              header: 'Lastname',
              field: 'lastname',
              sortable: true,
            },
            {
              header: 'Email',
            },
            {
              header: 'Phone',
            },
            {
              // Team tags: Deprecated
              // header: 'Tags',
            },
            {
              header: 'Active Debate',
            },
          ],
        ],
      };
    },
    tableTeamOptions() {
      return {
        // globalFilterFields: ['name'],
        tableName: 'tableClientTeam',
        archiveSelected: {
          action: async ({ items, success, failed }) => {
            await this.archiveMultipleTeams(items, success, failed, true);
          },
          title: 'Archive Teams',
          tooltip: 'Archive the checked teams',
        },
        restoreSelected: {
          action: async ({ items, success, failed }) => {
            await this.archiveMultipleTeams(items, success, failed, false);
          },
          title: 'Restore Teams',
          tooltip: 'Restore archived items',
        },
        headerConfig: [
          [
            {
              header: 'Name',
              field: 'name',
              sortable: true,
            },
            // Team tags: Deprecated
            // {
            //     header: 'Tags',
            // },
          ],
        ],
      };
    },
    tablePeopleConfig() {
      const tableConfig = [
        {
          column: 'First Name',
          field: 'firstname',
          sortable: true,
          model: row => {
            return row.firstname;
          },
          index: 1,
          // Not currently used:
          // action : (row) => {this.openUpdateContacts(), this.updateData = row}
        },
        {
          column: 'Last Name',
          field: 'lastname',
          sortable: true,
          model: row => {
            return row.lastname;
          },
          index: 2,
        },

        {
          column: 'Email',
          field: 'email',
          sortable: true,
          index: 3,
        },

        {
          column: 'Phone/Text',
          field: 'phonenumber',
          sortable: true,
          index: 4,
        },
        // Team tags: Deprecated
        // {
        //     column: 'Tags',
        //     field: 'tags',
        //     filter: {
        //       type: 'select',
        //       options: this.tagsOptions,
        //     },
        // },
        {
          column: '',
          field: 'archived',
          filter: {
            type: 'checkbox',
            text: 'Show Archived Contacts',
          },
        },
      ];
      return tableConfig;
    },
    tableTeamConfig() {
      const tableConfig = [
        {
          column: 'Name',
          field: 'name',
          sortable: true,
          link: row => {
            return `/contacts/manageteam?teamId=${row._id}`;
          },
          index: 1,
        },
        // Team tags: Deprecated
        // {
        //     column: 'Tags',
        //     sortable: true,
        //     field: 'tags',
        //     filter: {
        //       type: 'select',
        //       options: this.teamTagsOptions,
        //     },
        // },
        {
          column: '',
          field: 'archived',
          filter: {
            type: 'checkbox',
            text: 'Show Archived Contacts',
          },
        },
      ];
      return tableConfig;
    },
  },
  methods: {
    ...mapActions([
      'loadMyContacts',
      'addMyContacts',
      'loadMyTeams',
      'getTeamList',
      'updateContact',
    ]),
    openAddContacts() {
      if (this.adding) return;
      this.adding = true;
      this.$refs.peopleDataTable.addEditableRow();
    },
    openCreateTeam() {
      this.$router.push('/contacts/manageteam');
    },

    closeAddContacts() {
      this.adding = false;
    },

    async loadTeams({ sortColumn, sortDirection, filters }) {
      const res = await this.getTeamList({ sortColumn, sortDirection, filters });
      // Handle null/undefined response (e.g., from 404 error)
      if (!res) {
        return {
          results: [],
          page: 0,
          resultsPerPage: 0,
          totalCount: 0,
        };
      }
      // Team tags: Deprecated
      // this.teamTagsOptions = []
      // if(filters?.archived?.value) {
      //   res.results.map((item) => {
      //     this.teamTagsOptions = [...this.teamTagsOptions, ...item.tags.filter((tag) => !this.teamTagsOptions.includes(tag))]
      //   })
      // } else {
      //   res.results.map((item) => {
      //     if(!item.archived) this.teamTagsOptions = [...this.teamTagsOptions, ...item.tags.filter((tag) => !this.teamTagsOptions.includes(tag))]
      //   })
      // }
      return res;
    },

    async loadContacts({ sortColumn, sortDirection, filters }) {
      let res = {
        results: this.selectedPeople,
        page: 0,
        resultsPerPage: 0,
        totalCount: this.selectedPeople.length,
      };
      res = await this.loadMyContacts({ sortColumn: '', sortDirection: 'asc', filters });
      this.selectedPeople = res.results;
      // Team tags: Deprecated
      // this.tagsOptions = []
      // if(filters?.archived?.value) {
      //   res.results.map((item) => {
      //     this.tagsOptions = [...this.tagsOptions, ...item.tags.filter((tag) => !this.tagsOptions.includes(tag))]
      //   })
      // } else {
      //   res.results.map((item) => {
      //     if(!item.archived) this.tagsOptions = [...this.tagsOptions, ...item.tags.filter((tag) => !this.tagsOptions.includes(tag))]
      //   })
      // }
      res.results = this.sortAndFilter({ data: res.results, sortColumn, sortDirection, filters });
      return res;
    },

    async handleContactUpdate(data) {
      if (data._id) {
        await this.updateContact([data]);
        this.contactsUpdated++;
        this.adding = false;
      } else {
        await this.addMyContacts({ contacts: [data] });
        this.contactsUpdated++;
        this.adding = false;
      }
    },

    async archiveMultipleContacts(items, success, failed, archive) {
      try {
        for (let i = 0; i < items.length; i++) {
          let contact = items[i];
          contact.archived = archive;
          await this.updateContact([contact]);
        }
        if (success) success();
        this.$refs.peopleDataTable.loadData();
      } catch (e) {
        console.log(e);
        if (failed) failed();
      }
    },
    // Team tags: Deprecated
    // addTags(value) {
    //   if (!value) return;
    //   this.tags.push(value);
    //   this.peopleAddTags(value)
    // },
    // async peopleAddTags(tags,success, failed) {
    //   try {
    //     for (let i = 0; i < this.selectedPeople.length; i++) {
    //         let contact = this.selectedPeople[i]
    //         contact.tags.push(tags)
    //         await this.updateContact([contact]);
    //     }
    //     if(success) success();
    //     this.$refs.peopleDataTable.loadData();
    //   } catch (e) {
    //     console.log(e);
    //     if(failed) failed();
    //   }
    // },

    // removeTag(index) {
    //   this.tags.splice(index, 1);
    //   this.peopleRemoveTags(index)
    // },
    // async peopleRemoveTags(index,success, failed) {
    //   try {
    //     for (let i = 0; i < this.selectedPeople.length; i++) {
    //         let contact = this.selectedPeople[i]
    //         contact.tags.splice(index, 1)
    //         await this.updateContact([contact]);
    //     }
    //     if(success) success();
    //     this.$refs.peopleDataTable.loadData();
    //   } catch (e) {
    //     console.log(e);
    //     if(failed) failed();
    //   }
    // },

    async archiveMultipleTeams(items, success, failed, archive) {
      try {
        for (let i = 0; i < items.length; i++) {
          let team = items[i];
          let teamId = team._id;
          team.archived = archive;
          delete team._id;
          await xhr.updateTeam(teamId, { team }, this.idToken);
        }
        if (success) success();
        this.$refs.teamDataTable.loadData();
      } catch (e) {
        console.log(e);
        if (failed) failed();
      }
    },
  },
};
</script>
<style></style>
